<template>
<section class="crumb-wrapper">
  <ul class="crumb">
    <li class="crumb-item home-crumb-item">
      <i class="crumb-item-icon"></i>
      <span class="crumb-item-text">评分系统</span>
    </li>
    <li
      v-for="(opt, index) in opts"
      :key="index"
      class="crumb-item"
    >
      <span class="crumb-item-text">{{opt.label}}</span>
    </li>
    <li class="crumb-item-date">{{new Date().format('YYYY-MM-DD')}}</li>
  </ul>

  <section class="layout-content">
    <slot />
  </section>
</section>
</template>

<script>
export default {
  name: 'LayoutCrumb',
  props: {
    opts: {
      required: true,
      type: Array
    }
  }
}
</script>

<style lang="scss" scoped>
.crumb-wrapper {
  $CRUMB-HEIGHT: 31px;

  position: relative;
  width: 100%;
  height: 100%;
  padding-top: $CRUMB-HEIGHT;

  .crumb {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: $CRUMB-HEIGHT;
    margin: 0;
    padding: 3px 20px;
    line-height: 24px;
    border-bottom: 1px solid #cfd0d3;
    color: #363a42;

    .crumb-item {
      float: left;
      height: 100%;

      &:not(:first-child) {
        margin-left: 20px;

        &:before {
          content: ">";
          float: left;
          line-height: 22px;
        }
      }

      &.home-crumb-item {
        color: #349efb;

        .crumb-item-icon {
          background-image: url("./../../assets/imgs/icohome.png");
        }
      }

      > * {
        display: block;
        float: left;
        height: 100%;
      }

      .crumb-item-icon {
        width: 24px;
        height: 24px;
        background: {
          position: center;
          size: auto 100%;
          repeat: no-repeat;
        }
      }

      .crumb-item-text {
        margin-left: 20px;
      }
    }

    .crumb-item-date {
      float: right;
    }
  }
}

.layout-content {
  position: relative;
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Layout/Crumb.vue